/**
 * 网络管理，待加入列表，连接状态
 */
enum ConnectionState {
    INVITED = '已邀请',
    WAITING = '待接受',
    CONNECTED = '已连接',
    CANCELED = '已取消'
}
 
export default ConnectionState;



// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/entry/constant/networkEnum/ConnectionState.ts